<div #zoomDiv class="jk-row-border">
  <h4 class="text-center text-blue-700">海期下單</h4>
  <app-jkcombobox [styleDisplay]="'flex'" label="帳號" [(value)]="stktqSrv.newItem.TQ002" [width]="'200px'"
    [items]="stkmbSrv.seaAccountList">
  </app-jkcombobox>
  <mat-tab-group #masterTabGroup (selectedTabChange)="onMasterTabChange($event)">
    <mat-tab #myTabGrid label="下單">
      <div class="jk-row-border" style="width: 350px">

          <app-jkcombobox [styleDisplay]="'flex'" label="交易所" [(value)]="exchangeId" [items]="stkmwSrv.idNameList"
            (valueChange)="onExchangeValueChange($event)">
          </app-jkcombobox>
          <app-jkautocomplete label="商品代號" [showClearButton]="true" valueExpr="id" displayExpr="name"
            [itemList]="stkmaallSrv.exchangeStockList" [(value)]="stockno">
          </app-jkautocomplete>
          <div class="flex">
            <app-jknumberedit [visible]="true" [label]="'委託價'" [required]="true" [(value)]="stktqSrv.newItem.TQ008"
              width="100" [styleDisplay]="'flex'">
            </app-jknumberedit>
            <app-jkcheckboxYN label="當沖" [(valueYN)]="stktqSrv.tq014YN">
            </app-jkcheckboxYN>
          </div>

          <div class="flex">
            <app-jknumberedit [visible]="true" [label]="'口數'" [required]="true" [(value)]="stktqSrv.newItem.TQ017"
              width="60" [styleDisplay]="'flex'">
            </app-jknumberedit>
            <app-jkbuttongroup hint="'買賣'" [items]="buysaleList" [(value)]="stktqSrv.buysale"
              (valueChange)="onBuySaleValueChange($event)">
            </app-jkbuttongroup>
          </div>

          <!-- <app-jkautocompleteAsync label="商品代號Async" [showClearButton]="true" valueExpr="id" displayExpr="name"
        [itemList]="stkmaallSrv.exchangeStockList" [(value)]="stktqSrv.tq005" >
      </app-jkautocompleteAsync> -->
          <div>現價:{{stklg.LG010}} 開盤價:{{stklg.LG007}} 最高價:{{stklg.LG008}} 最低價:{{stklg.LG009}}</div>
          <div class="flex">
            <app-jkbuttongroup [styleDisplay]="'flex'" [title]="'條件'" [items]="stktqSrv.tq015List"
              [(value)]="stktqSrv.tq015">
            </app-jkbuttongroup>
            <app-jkcheckboxYN label="暫存" [(valueYN)]="stktqSrv.newItem.TQ020">
            </app-jkcheckboxYN>
          </div>
          <app-jkbuttongroup [title]="'限價'" [items]="stktqSrv.tq016List" [(value)]="stktqSrv.tq016"
            (valueChange)="onValueChange($event)">
          </app-jkbuttongroup>
          <!-- <app-jkradiogroup [title]="'交易類型'" [items]="stktqSrv.tq015List" [(value)]="stktqSrv.tq015"
        >
      </app-jkradiogroup>
      <app-jkradiogroup [title]="'限價'" [items]="stktqSrv.tq016List" [(value)]="stktqSrv.tq016"
        (valueChange)="onValueChange($event)">
      </app-jkradiogroup> -->
          <button type="button" class="btn w-full" [class.btn-primary]="true"
            [class.btn-primary-red]="stktqSrv.buysale === '0'"
            [class.btn-primary-green]="stktqSrv.buysale === '1'"
            (click)="doSend()">{{stktqSrv.buysaleTitle}}</button>
        </div>
    </mat-tab>

    <mat-tab #myDetailTab label="委託查詢">
      <app-jkdatefield label="委託日期" [(value)]="date" [showClearButton]="true"
        (valueChange)="onTQ001ValueChange($event)">
      </app-jkdatefield>

      <div class="flex">
        <button class="btn" [class.btn-info]="true" (click)="doQuery()">查詢</button>
        <button class="btn" [class.btn-primary]="true" (click)="doChangePrice()">改價</button>
        <button class="btn" [class.btn-warning]="true" (click)="doChangeQty()">改量</button>
        <button class="btn" [class.btn-danger]="true" (click)="doDelete()">刪單</button>
      </div>
      <mat-divider></mat-divider>
      <div style="height: 400px;">
        <app-jkgridwin #jkgridwin (afterGridReady)="afterGridReady($event) ">
        </app-jkgridwin>
      </div>
    </mat-tab>
    <mat-tab #myDetailTab label="回報查詢">
      <app-jkdatefield label="回報日期" [(value)]="date" [showClearButton]="true" (valueChange)="onDateValueChange($event)">
      </app-jkdatefield>
      <div class="flex">
        <button class="btn" [class.btn-info]="true" (click)="doQueryReply()">回報查詢</button>
        <button class="btn" [class.btn-primary]="true" (click)="doComfirm()">
          <mat-icon fontIcon="check_circle"></mat-icon>過帳
        </button>
      </div>
      <mat-divider></mat-divider>
      <div style="height: 400px;">
        <app-jkgridwin (afterGridReady)="afterGridReadyReply($event) ">
        </app-jkgridwin>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
